import { render } from "./g-form.vue?vue&type=template&id=41ffb40a&ts=true"
import script from "./g-form.vue?vue&type=script&lang=tsx"
export * from "./g-form.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__